<template>
    <df-app title="Nano-Degrees">
        <df-solutions filterable :solutions="solutions"/>
    </df-app>
</template>

<script>
    import Solution from '../../models/Solution';

    import DfSolutions from '../blocks/DfSolutions';

    export default {
        components: { DfSolutions },


        data: () => ({
            solutions: null,
        }),

        async created() {
            this.$Progress.start();
            try {
                this.solutions = await Solution.params({ type: 'nanodegree' }).get();
                this.$Progress.finish();
            } catch (response) {
                this.$Progress.fail();
            }
        },
    };
</script>
